/**
 * @author Ariel
 * @description 共建店管理页面配置
 * @Date 2020/1/15
 */
import React from "react";
import {WizTableForm} from "../../common";
import {component_tool} from "../../../tool";
let { WizModal } = component_tool
const organizationConfig = WizTableForm.Config.organization(this, { apiParams: { state: 1 } })

let componentName = 'dealerUnion'
const columns = [
  {
    name: 'id',
    key: 'id',
    formItem: { type: 'hidden' }
  },
  {
    title: '组织',
    name: 'orgIds',
    searchItem: {
      ...organizationConfig,
      diy: WizTableForm,
    }
  },
  {
    title: '共建类型',
    name: 'type',
    key: 'type',
    dataIndex: 'type',
    dict: [
      { code: 1, codeName: '销售售后共建' },
      { code: 2, codeName: '售后共建' }
    ],
    searchItem: {
      type: 'select'
    },
    tableItem: {}
  },
  {
    title: '共建状态',
    name: 'state',
    key: 'state',
    dataIndex: 'state',
    dict: [
      { code: 1, codeName: '有效' },
      { code: 0, codeName: '无效' }
    ],
    searchItem: {
      type: 'select'
    },
    tableItem: {}
  },
  {
    title: '共建店1',
    dataIndex: 'orgId1',
    key: 'orgId1',
    tableItem: {
      children: [
        {
          title: '品牌',
          dataIndex: 'brandName1',
          key: 'brandName1'
        },
        {
          title: '经销商简称',
          dataIndex: 'shortName1',
          key: 'shortName1'
        },
        {
          title: '销售代码',
          dataIndex: 'preSalesNumber1',
          key: 'preSalesNumber1'
        },
        {
          title: '售后代码',
          dataIndex: 'afterSalesNumber1',
          key: 'afterSalesNumber1'
        },
        {
          title: '开店状态',
          key: 'dealerState1',
          dataIndex: 'dealerState1'
        }
      ]
    },
  },
  {
    title: '共建店2',
    dataIndex: 'orgId2',
    key: 'orgId2',
    tableItem: {
      children: [
        {
          title: '品牌',
          dataIndex: 'brandName2',
          key: 'brandName2'
        },
        {
          title: '经销商简称',
          dataIndex: 'shortName2',
          key: 'shortName2'
        },
        {
          title: '销售代码',
          dataIndex: 'preSalesNumber2',
          key: 'preSalesNumber2'
        },
        {
          title: '售后代码',
          dataIndex: 'afterSalesNumber2',
          key: 'afterSalesNumber2'
        },
        {
          title: '开店状态',
          key: 'dealerState2',
          dataIndex: 'dealerState2'
        }
      ]
    }
  }
];

const templateConfig = {
  mainProps: {},
  content: {
    name: "WizTableList",
    params: {
      columns,
      searchBarProps: {
        cols: {
          xs: 24,
          md: 12,
          xl: 8
        },
        buttonSort: ['import','export'],
        buttons: [
          {
            key: 'import',
            custom: true,
            params: { icon: 'import', children: '导入'},// type: 'upload',
            customOnClick: {
              key: 'jumpPage',
              params: {
                key: 'push',
                pathname: '/org/dealerUnion/dealerUnionImport'
              }
            }
          },
          {
            key: 'export',
            custom: true,
            params: {icon: 'export', children: '导出', type: 'export'},
            customOnClick: {
              key: 'action',
              params: {
                apiKey: "export",
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                return {...filters}
              }
            }
          }
        ]
      },
      dataTableProps: {
        rowKey: "id",
        isScroll: true,
        bordered: true,
        paging: false,
        loading: false
      },
      rowOperateSort: ['enableOrDisable'],
      rowOperateProps: {
        width: 80,
        fixed: 'right',
      },
      rowOperateView: [
        {
          key: "enableOrDisable",
          custom: true,
          params: { children: "启用"},
          textFormat: {
            recordKey: 'state',
            dirt: { '1': '禁用', '0': '启用', }
          },
          customOnClick: {
            key: "action",
            params: {
              apiKey: "enable",
              apiParams: {}
            },
            formatParams: (rows, record, filters, callback) => {
              const content = `您确定要${
                record['state'] === 0 ? "启用" : "禁用"
              }该共建店吗？`;
              WizModal.confirm({
                title: '注意', content,
                onOk: () => {
                  callback && callback({
                    id: record['id'],
                    ...filters
                  })
                },
                onCancel() {
                }
              });
              return null
            }
          }
        }
      ],
      commonOperate: {
        delete: false
      }
    }
  }
};

const apis = {
  list: {
    path: `${componentName}/list`,
    payload: {
      key: `${componentName}@list`,
      apiParams: { pageNum: 1, pageSize: 10 }
    }
  },
  export: {
    path: `${componentName}/export`,
    payload: {
      key: `${componentName}@export`,
      apiParams: {}
    }
  },
  enable: {
    path: `${componentName}/enable`,
    payload: {
      key: `${componentName}@enable`,
      apiParams: {}
    }
  },
};

let reduxTemplateConfig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    ...args
  }
};

export { reduxTemplateConfig, templateConfig };
